import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Filter } from '../../../models/filter-models';
import { EndgameContent, EndgameContentIconMap, TieringMode } from '../../../models/enums';
import { FilterService } from '../../../services/filter.service';
import { FilterTitleComponent } from '../../../common/filter-title/filter-title.component';
import { UniquesTierService } from '../../../services/tiering/uniques-tier.service';
import { ChanceBasesTierService } from '../../../services/tiering/chance-bases-tier.service';
import { BaseComponent } from '../../../common/base.component';
import { SelectComponent, SelectOptionComponent } from '../../../common/select/select.component';
import { AutocompleteComponent, AutocompleteOption } from '../../../common/autocomplete/autocomplete.component';
import { ItemDataService } from '../../../services/item-data.service';
import { CustomUniquesTieringModeDialogComponent } from '../../../custom-uniques-tiering-mode-dialog/custom-uniques-tiering-mode-dialog.component';
import { PresetsService } from '../../../services/presets.service';

@Component({
  selector: 'app-unique-general-filters',
  imports: [FormsModule, FilterTitleComponent, SelectComponent, SelectOptionComponent, AutocompleteComponent, CustomUniquesTieringModeDialogComponent],
  templateUrl: './unique-general-filters.component.html',
  styleUrl: './unique-general-filters.component.scss'
})
export class UniqueGeneralFiltersComponent extends BaseComponent implements OnChanges {
  @Input({ required: true }) filter!: Filter;
  @Output() favouriteEndgameContentChanged = new EventEmitter<void>();

  classes: { name: string, image: string }[] = [];
  endgameContentOptions: AutocompleteOption[] = [];
  favouriteEndgameContentSelection: string[] = ['All'];
  showCustomTieringDialog = false;

  constructor(
    private filterService: FilterService,
    private uniquesTierService: UniquesTierService,
    private chanceBasesTierService: ChanceBasesTierService,
    private itemDataService: ItemDataService,
    private presetsService: PresetsService,
  ) {
    super();
    this.classes = this.itemDataService.getClasses();
    this.endgameContentOptions = [...this.presetsService.endgameContent, ...this.presetsService.endgameBosses]
      .map(c => ({ name: c, image: EndgameContentIconMap[c] }));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filter']) {
      this.syncFavouriteEndgameContentSelection();
    }
  }

  updateFilter() {
    this.filterService.updateFilter();
  }

  rebuildTierList() {
    this.uniquesTierService.combineTieredUniques(this.filter);
    this.chanceBasesTierService.combineTieredChanceBases(this.filter);
    this.filterService.updateFilter();
  }

  favouriteEndgameContentChangedHandler(values: string[]) {
    this.filter.favouriteEndgameContent = values as (EndgameContent | 'All')[];
    this.syncFavouriteEndgameContentSelection();
    this.rebuildTierList();
    this.favouriteEndgameContentChanged.emit();
  }

  uniqueTieringModeChanged(mode: TieringMode) {
    this.uniquesTierService.setTieringMode(mode, this.filter);
    this.filterService.updateFilter(true);
  }

  openCustomTieringDialog() {
    this.showCustomTieringDialog = true;
  }

  closeCustomTieringDialog() {
    this.showCustomTieringDialog = false;
    this.updateFilter();
  }

  private syncFavouriteEndgameContentSelection() {
    if (!this.filter) return;
    this.favouriteEndgameContentSelection = [...this.filter.favouriteEndgameContent];
  }
}
